<template>
  <div class="card" style="padding: 15px;">
    <div class="card-header">
      <h4 style="font-size: 35px;">Hola, {{ nombreUsuario }}</h4>
      <p style="color:grey">Información actualizada, {{fecha_hoy | date}}</p>
    </div>
    <div class="card-content">
      <div class="row">
   
    <div class="col-md-3">
      <nomicard title="Ingresos totales por SSR" style="background-color: #45a22f; color:white;" imgRoute="static/img/nomina/ganador.png" :value="realizadas" :footerText="cardFooterText"></nomicard>
    </div>
    <div class="col-md-3">
      <nomicard title="Servicios no completados" style="background-color: #d32437; color:white;" imgRoute="static/img/nomina/perdida.png" :value="canceladas" :footerText="cardFooterText"></nomicard>
    </div>
    <div class="col-md-3">
      <nomicard title="Ingreso en copagos" style="background-color: #21659e; color:white;" imgRoute="static/img/nomina/bolsa-de-dinero.png" :value="copago" :footerText="cardFooterText"></nomicard>
    </div>
    <div class="col-md-3">
      <nomicard title="Pago a terapeutas" style="background-color: #da9729; color:white;" imgRoute="static/img/nomina/dar-dinero.png" :value="terapeuta" :footerText="cardFooterText"></nomicard>
    </div>
  </div>
    </div>
  </div>
</template>
<script>
import StatsCard from "src/components/UIComponents/Cards/StatsCard.vue";
import nomicard from "src/components/aDashboard/nomina/cardnomina.vue"
import crearAlerta from "../../../global-services/crearAlerta";
import axiosInstance from "src/global-services/axiosInstance";
import formatearPesosColombianos from "../../../global-services/formatear-pesos";
import getCurrentDate from "../../../global-services/fecha-actual";
export default {
  components: {
    StatsCard,
    nomicard
  },
  data() {
    return {
      realizadas: 0,
      canceladas: 0,
      copago: 0,
      terapeuta: 0,
      cardFooterText: 'Información actual',
      nombreUsuario: localStorage.getItem('nombre'),
      fecha_hoy: getCurrentDate()
    };
  },
  methods: {
    getInformationToday: async function () {
      try {
        const date = this.calcularFechaActual();
        const BASE_URL = `api/informationNominaToday/${date}/${date}`;
        const response = await axiosInstance.get(BASE_URL);
        const information = response.data.data[0];
        this.realizadas = formatearPesosColombianos(information.Realizadas);
        this.canceladas = formatearPesosColombianos(information.Canceladas);
        this.copago = formatearPesosColombianos(information.Copago);
        this.terapeuta = formatearPesosColombianos(information.Terapeuta);
      } catch (error) {
        console.log(error);
      } finally {
      }
    },
    calcularFechaActual() {
      var fecha_hoy = new Date();

      var ahora_ano = fecha_hoy.getFullYear();
      var ahora_mes = ("0" + (fecha_hoy.getMonth() + 1)).slice(-2);
      var ahora_dia = ("0" + fecha_hoy.getDate()).slice(-2);

      return `${ahora_ano}-${ahora_mes}-${ahora_dia}`;
    },
  },
  mounted() {
    this.getInformationToday();
  },
};
</script>


// WEBPACK FOOTER //
// src/components/aDashboard/nomina/informacionDia.vue